import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
// import PropTypes from "prop-types";
import * as paperBinActions from "../actions/paperBinActions";
import StateManager from "../../shared/utils/StateManager";
import WorkersTab from "../../shared/components/tabs/workers/WorkersTab";
import {I18nUtils} from "../../../i18n/I18nUtils";

class PaperBinTabWorkers extends React.Component {

  static TAB_ID = 'workers';

  constructor(init) {
    super(init);

    this.recoverWorker = this.recoverWorker.bind(this);
  }

  recoverWorker(worker){
    this.props.paperBinActions.recoverWorker(worker);
  }

  static renderTabHeader() {
    return (
      <li role="presentation" className="active">
        <a
            href={'#' + this.TAB_ID}
            data-toggle="tab"
            aria-expanded="true"
            children={I18nUtils.tr('TR_TRABAJADORES').toUpperCase()}
        />
      </li>
    );
  }

  render() {
    return (
      <div role="tabpanel" className="tab-pane fade active in" id={PaperBinTabWorkers.TAB_ID}>
        <WorkersTab
          id={StateManager.PAPER_BIN_TAB_WORKERS}
          title={I18nUtils.tr('TR_RECUPERAR_TRABAJADORES')}
          action={this.recoverWorker}
          actionText={I18nUtils.tr('TR_RECUPERAR')}
          showOutsource={true}
          showDeleted={true}
        />
      </div>
    );
  }

}

const mapDispatchToProps = dispatch => ({
  paperBinActions: bindActionCreators(paperBinActions, dispatch),
});

export default connect(null, mapDispatchToProps)(PaperBinTabWorkers)

PaperBinTabWorkers.propTypes = {
};

PaperBinTabWorkers.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/paperbin/components/PaperBinTabWorkers.js